import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'currency-monero', 'CurrencyMonero', [["path",{"d":"M3 18h3v-11l6 7l6 -7v11h3"}]]);